interface ValidationError {
  field: string;
  message: string;
}

interface FormValues {
  quarryName?: string;
  quarryId?: string;
  phone?: string;
  addressField?: string;
  addressLat?: string;
  addressLng?: string;
  accountTerms?: string;
  accountTermsCustom?: string;
  accountLimit?: string;
  disableCoordinates?: boolean;
  notes?: string;
  [key: string]: any;
}

interface HandleSubmitParams {
  formValues: FormValues;
  daySwitchVals: { [key: string]: boolean };
  disableCoordinatesValue: boolean;
}

export const handleSubmit = (params: HandleSubmitParams): ValidationError[] => {
  const { formValues, daySwitchVals, disableCoordinatesValue } = params;
  const errors: ValidationError[] = [];

  const requiredFields = [
    { name: "quarryName", label: "Quarry Name" },
    { name: "quarryId", label: "Quarry ID" },
    { name: "phone", label: "Quarry Phone Number" },
    { name: "accountTerms", label: "Account Terms" },
    { name: "accountLimit", label: "Account Charge Limit" },
  ];

  requiredFields.forEach((field) => {
    const value = formValues[field.name];
    if (!value || (typeof value === "string" && value.trim() === "")) {
      errors.push({
        field: field.name,
        message: `${field.label} is required`,
      });
    }
  });

  if (formValues.accountTerms === "Custom Input") {
    if (
      !formValues.accountTermsCustom ||
      (typeof formValues.accountTermsCustom === "string" &&
        formValues.accountTermsCustom.trim() === "")
    ) {
      errors.push({
        field: "accountTermsCustom",
        message: "Custom Terms is required",
      });
    }
  }

  if (formValues.phone) {
    const digitsOnly = formValues?.phone?.replace(/[^\d]/g, "");
    if (digitsOnly?.length < 10) {
      errors.push({
        field: "phone",
        message: "Phone number should contain 10 digits!",
      });
    }
  }

  if (disableCoordinatesValue) {
    if (!formValues.addressLat || formValues.addressLat === "") {
      errors.push({
        field: "addressLat",
        message: "Latitude is required",
      });
    }
    if (!formValues.addressLng || formValues.addressLng === "") {
      errors.push({
        field: "addressLng",
        message: "Longitude is required",
      });
    }
  } else {
    if (!formValues.addressField || formValues.addressField === "") {
      errors.push({
        field: "addressField",
        message: "Location is required",
      });
    }
  }

  const days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  days.forEach((day) => {
    if (daySwitchVals[day]) {
      const startTimeField = `${day}StartTime`;
      const endTimeField = `${day}EndTime`;
      const dayLabel = day.charAt(0).toUpperCase() + day.slice(1);

      if (!formValues[startTimeField]) {
        errors.push({
          field: startTimeField,
          message: `Required`,
        });
      }

      if (!formValues[endTimeField]) {
        errors.push({
          field: endTimeField,
          message: `Required`,
        });
      }

      if (formValues[startTimeField] && formValues[endTimeField]) {
        const startTime = new Date(`2000-01-01 ${formValues[startTimeField]}`);
        const endTime = new Date(`2000-01-01 ${formValues[endTimeField]}`);

        if (endTime <= startTime) {
          errors.push({
            field: endTimeField,
            message: `Requires higher time!`,
          });
        }
      }
    }
  });

  if (errors.length > 0) {
    return errors;
  }
  return [];
};
